import type { ICard } from "../../cardsSlice";

export const pentaclesData: ICard[] = [
{
    id: "pentacles_1",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 1,
    name: "Туз Пентаклей",
    nameEn: "Ace of Pentacles",

    keywords: ["Возможность", "Материальный старт", "Ресурсы"],

    symbolism: [
      "Рука из облака держит золотой пентакль",
      "Сад и горы",
      "Цветущий арочный вход"
    ],
    symbolismInterpretation: "Начало материальных возможностей, шанс на рост",

    archetype: "Семя богатства",
    psychology: "Ощущение перспектив и потенциала",

    upright: {
      personality: "Прагматизм, готовность к делу",
      relationships: "Стабильное предложение",
      work: "Запуск прибыльного проекта",
      spirituality: "Материальные ресурсы как инструмент пути",
      examples: ["Покупка земли", "Договор", "Подарок"]
    },
    reversed: {
      meaning: "Упущенная возможность",
      nuances: "Затруднения с финансами"
    },

    associations: ["Монета", "Сад", "Врата"],
    combinations: [
      "С Магом — реализация идеи в материальном мире",
      "С Башней — потеря вложений"
    ],
    readingTips: [
      "Схватить шанс вовремя",
      "Подготовить фундамент для роста"
    ],
    selfQuestions: [
      "Какая возможность открывается?",
      "Что мне нужно для её реализации?"
    ]
  },
{
    id: "pentacles_2",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 2,
    name: "Двойка Пентаклей",
    nameEn: "Two of Pentacles",

    keywords: ["Баланс", "Гибкость", "Управление ресурсами"],

    symbolism: [
      "Человек жонглирует двумя пентаклями в бесконечной петле",
      "Корабли на волнах",
      "Морской фон"
    ],
    symbolismInterpretation: "Гибкость в управлении задачами и финансами",

    archetype: "Жонглёр ресурсов",
    psychology: "Способность адаптироваться к переменам",

    upright: {
      personality: "Гибкость, умение распределять внимание",
      relationships: "Баланс личного и общего",
      work: "Многозадачность, финансовое планирование",
      spirituality: "Поиск гармонии в переменах",
      examples: ["Переключение между проектами", "Стабилизация бюджета"]
    },
    reversed: {
      meaning: "Хаос, переутомление",
      nuances: "Неудачная попытка совмещать задачи"
    },

    associations: ["Бесконечность", "Море", "Корабли"],
    combinations: [
      "С Шестёркой Мечей — баланс в пути",
      "С Башней — потеря контроля над делами"
    ],
    readingTips: [
      "Выставить приоритеты",
      "Не браться за лишнее"
    ],
    selfQuestions: [
      "Что я пытаюсь удержать одновременно?",
      "Что можно временно отложить?"
    ]
  },
{
    id: "pentacles_3",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 3,
    name: "Тройка Пентаклей",
    nameEn: "Three of Pentacles",

    keywords: ["Сотрудничество", "Мастерство", "Обучение"],

    symbolism: [
      "Мастер работает над собором",
      "Два человека наблюдают и советуют",
      "Пентакли в архитектуре"
    ],
    symbolismInterpretation: "Совместная работа, обмен опытом, развитие навыков",

    archetype: "Мастер и ученики",
    psychology: "Открытость обучению и обратной связи",

    upright: {
      personality: "Профессионализм, коммуникабельность",
      relationships: "Совместные проекты",
      work: "Командная работа, наставничество",
      spirituality: "Обучение у других",
      examples: ["Работа в команде", "Обучение ремеслу"]
    },
    reversed: {
      meaning: "Конфликты в команде",
      nuances: "Недооценка чужого вклада"
    },

    associations: ["Собор", "Строительство", "Инструменты"],
    combinations: [
      "С Восьмёркой Пентаклей — развитие мастерства",
      "С Пятёркой Жезлов — конкуренция внутри команды"
    ],
    readingTips: [
      "Учиться у коллег",
      "Делиться опытом"
    ],
    selfQuestions: [
      "Чей вклад я могу признать?",
      "Чему я готов научиться?"
    ]
  },
{
    id: "pentacles_4",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 4,
    name: "Четвёрка Пентаклей",
    nameEn: "Four of Pentacles",

    keywords: ["Сохранение", "Контроль", "Стабильность"],

    symbolism: [
      "Человек держит монету на груди",
      "Две монеты под ногами",
      "Монета над головой"
    ],
    symbolismInterpretation: "Желание удержать ресурсы и позиции",

    archetype: "Сторож сокровищ",
    psychology: "Стремление к стабильности, страх потерь",

    upright: {
      personality: "Надёжность, практичность",
      relationships: "Ограничение эмоций",
      work: "Стабильная прибыль, контроль расходов",
      spirituality: "Сохранение традиций",
      examples: ["Сбережения", "Ограничение доступа", "Отказ делиться"]
    },
    reversed: {
      meaning: "Скупость или расточительство",
      nuances: "Потеря контроля"
    },

    associations: ["Монеты", "Контроль", "Стабильность"],
    combinations: [
      "С Девяткой Пентаклей — финансовая безопасность",
      "С Башней — утрата накопленного"
    ],
    readingTips: [
      "Не держаться за лишнее",
      "Инвестировать в развитие"
    ],
    selfQuestions: [
      "Что я боюсь потерять?",
      "Что удерживаю без нужды?"
    ]
  },
{
    id: "pentacles_5",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 5,
    name: "Пятёрка Пентаклей",
    nameEn: "Five of Pentacles",

    keywords: ["Потери", "Трудности", "Нужда"],

    symbolism: [
      "Двое бедняков идут мимо витража с пентаклями",
      "Снег и холод",
      "Костыли"
    ],
    symbolismInterpretation: "Временные материальные или физические трудности",

    archetype: "Испытание нуждой",
    psychology: "Чувство исключённости и уязвимости",

    upright: {
      personality: "Выносливость, терпение",
      relationships: "Поддержка в трудностях",
      work: "Временные убытки",
      spirituality: "Поиск помощи",
      examples: ["Безработица", "Болезнь", "Потеря дохода"]
    },
    reversed: {
      meaning: "Выход из кризиса",
      nuances: "Поиск и получение поддержки"
    },

    associations: ["Снег", "Нищета", "Витраж"],
    combinations: [
      "С Шестёркой Пентаклей — помощь и милосердие",
      "С Звездой — надежда на восстановление"
    ],
    readingTips: [
      "Искать ресурсы вокруг",
      "Принимать помощь"
    ],
    selfQuestions: [
      "К кому я могу обратиться?",
      "Что поможет пройти этот этап?"
    ]
  },
{
    id: "pentacles_6",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 6,
    name: "Шестёрка Пентаклей",
    nameEn: "Six of Pentacles",

    keywords: ["Щедрость", "Баланс", "Поддержка"],

    symbolism: [
      "Богатый человек раздаёт монеты",
      "Весы в руке",
      "Двое просящих"
    ],
    symbolismInterpretation: "Обмен ресурсами и справедливое распределение",

    archetype: "Благодетель",
    psychology: "Готовность просить и давать помощь",

    upright: {
      personality: "Великодушие, справедливость",
      relationships: "Взаимная поддержка",
      work: "Гранты, инвестиции, бонусы",
      spirituality: "Кармический баланс",
      examples: ["Благотворительность", "Стипендия", "Справедливая сделка"]
    },
    reversed: {
      meaning: "Неравный обмен, зависимость",
      nuances: "Манипуляция помощью"
    },

    associations: ["Весы", "Дар", "Баланс"],
    combinations: [
      "С Пятёркой Пентаклей — выход из нужды через помощь",
      "Со Справедливостью — честные условия"
    ],
    readingTips: [
      "Оценить баланс брать/давать",
      "Фиксировать условия помощи"
    ],
    selfQuestions: [
      "Где я могу попросить/дать поддержку?",
      "Справедлив ли обмен?"
    ]
  },
{
    id: "pentacles_7",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 7,
    name: "Семёрка Пентаклей",
    nameEn: "Seven of Pentacles",

    keywords: ["Ожидание", "Оценка", "Терпение"],

    symbolism: [
      "Человек опирается на инструмент и смотрит на куст с пентаклями",
      "Пауза в работе",
      "Зрелые плоды"
    ],
    symbolismInterpretation: "Промежуточный итог, выбор продолжать или менять подход",

    archetype: "Садовник",
    psychology: "Терпение и трезвая оценка усилий",

    upright: {
      personality: "Выдержка, предусмотрительность",
      relationships: "Выжидание, созревание отношений",
      work: "Анализ прогресса, корректировка плана",
      spirituality: "Уважение к циклам",
      examples: ["Ретроспектива", "Пересмотр KPI", "Ожидание результата"]
    },
    reversed: {
      meaning: "Нетерпение, слабая отдача",
      nuances: "Непродуманные инвестиции"
    },

    associations: ["Куст", "Плод", "Пауза"],
    combinations: [
      "С Восьмёркой Пентаклей — перейти к системной работе",
      "С Колесом Фортуны — ждать цикла"
    ],
    readingTips: [
      "Мерить, прежде чем резать",
      "Отделять усилия от их эффективности"
    ],
    selfQuestions: [
      "Что реально приносит плоды?",
      "Где нужна корректировка?"
    ]
  },
{
    id: "pentacles_8",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 8,
    name: "Восьмёрка Пентаклей",
    nameEn: "Eight of Pentacles",

    keywords: ["Мастерство", "Практика", "Дисциплина"],

    symbolism: [
      "Мастер вырезает пентакль на монете",
      "Ряд готовых монет",
      "Сосредоточенный труд"
    ],
    symbolismInterpretation: "Системное обучение и оттачивание навыка",

    archetype: "Ученик ремесла",
    psychology: "Фокус, рутина, совершенствование",

    upright: {
      personality: "Трудолюбие, внимательность",
      relationships: "Работа над отношениями",
      work: "Апскиллинг, ремесленная добротность",
      spirituality: "Практика как путь",
      examples: ["Курс/стажировка", "Повышение квалификации"]
    },
    reversed: {
      meaning: "Халтура, выгорание от рутины",
      nuances: "Отсутствие роста"
    },

    associations: ["Инструмент", "Монеты", "Верстак"],
    combinations: [
      "С Тройкой Пентаклей — обучение в команде",
      "С Императором — стандартизация процессов"
    ],
    readingTips: [
      "Ставить микро-цели",
      "Следить за качеством"
    ],
    selfQuestions: [
      "Какой навык стоит прокачать?",
      "Что мешает качеству?"
    ]
  },
{
    id: "pentacles_9",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 9,
    name: "Девятка Пентаклей",
    nameEn: "Nine of Pentacles",

    keywords: ["Самодостаточность", "Комфорт", "Достижение"],

    symbolism: [
      "Женщина в саду с виноградом",
      "Сокол на руке",
      "Зрелые плоды"
    ],
    symbolismInterpretation: "Результат труда, личная независимость и вкус к качеству",

    archetype: "Хозяйка сада",
    psychology: "Удовольствие от заслуженного",

    upright: {
      personality: "Уверенность, вкус",
      relationships: "Зрелые границы, уважение",
      work: "Финансовая независимость",
      spirituality: "Благодарность плодам пути",
      examples: ["Пассивный доход", "Собственный бизнес", "Личный бренд"]
    },
    reversed: {
      meaning: "Зависимость, показная роскошь",
      nuances: "Страх одиночества"
    },

    associations: ["Сад", "Сокол", "Виноград"],
    combinations: [
      "С Четвёркой Пентаклей — защита капитала",
      "С Императрицей — процветание и комфорт"
    ],
    readingTips: [
      "Фиксировать результат",
      "Не путать ценность с ценником"
    ],
    selfQuestions: [
      "В чём моя самодостаточность?",
      "Как я поддерживаю качество жизни?"
    ]
  },
{
    id: "pentacles_10",
    arcana: "minor",
    suit: "pentacles",
    court: "simple",
    number: 10,
    name: "Десятка Пентаклей",
    nameEn: "Ten of Pentacles",

    keywords: ["Наследие", "Семья", "Капитал"],

    symbolism: [
      "Семья во дворе, старец, собаки",
      "Арка с десятью пентаклями",
      "Дом и гербы"
    ],
    symbolismInterpretation: "Долговечная структура благополучия и преемственности",

    archetype: "Род и дом",
    psychology: "Безопасность, опора на традицию",

    upright: {
      personality: "Ответственность, зрелость",
      relationships: "Родовая поддержка",
      work: "Семейный бизнес, долгосрочные активы",
      spirituality: "Служение роду/сообществу",
      examples: ["Наследование", "Покупка недвижимости", "Траст"]
    },
    reversed: {
      meaning: "Семейные споры о деньгах, рисковые вложения",
      nuances: "Слом традиций"
    },

    associations: ["Дом", "Род", "Арка"],
    combinations: [
      "С Десяткой Кубков — полная домашняя гармония",
      "С Башней — кризис семейного капитала"
    ],
    readingTips: [
      "Мыслить поколениями",
      "Диверсифицировать риски"
    ],
    selfQuestions: [
      "Какое наследие я строю?",
      "Как я защищаю семью/активы?"
    ]
  },
{
    id: "pentacles_11",
    arcana: "minor",
    suit: "pentacles",
    court: "page",
    number: 11,
    name: "Паж Пентаклей",
    nameEn: "Page of Pentacles",

    keywords: ["Обучение", "Практичность", "Намерение"],

    symbolism: [
      "Юноша разглядывает пентакль на ладонях",
      "Поле и роща",
      "Земные тона"
    ],
    symbolismInterpretation: "Фокус на навыке, первый практичный шаг",

    archetype: "Студент-реалист",
    psychology: "Концентрация, любознательность к делу",

    upright: {
      personality: "Собранность, усердие",
      relationships: "Ставит цель и действует",
      work: "Стажировка, обучение, первый заработок",
      spirituality: "Приземлённые практики",
      examples: ["Курс/сертификация", "Пилотный проект"]
    },
    reversed: {
      meaning: "Лень, рассеянность",
      nuances: "План без практики"
    },

    associations: ["Учёба", "Монета", "Поле"],
    combinations: [
      "С Восьмёркой Пентаклей — интенсивное обучение",
      "С Магом — превращение идеи в план"
    ],
    readingTips: [
      "Ставить измеримые цели",
      "Учиться через практику"
    ],
    selfQuestions: [
      "Какой навык я начну осваивать?",
      "Как измерю прогресс?"
    ]
  },
{
    id: "pentacles_12",
    arcana: "minor",
    suit: "pentacles",
    court: "knight",
    number: 12,
    name: "Рыцарь Пентаклей",
    nameEn: "Knight of Pentacles",

    keywords: ["Надёжность", "Рутина", "Последовательность"],

    symbolism: [
      "Всадник держит пентакль, стоит на месте",
      "Поля и борозды",
      "Тяжёлый конь"
    ],
    symbolismInterpretation: "Методичное движение вперёд, стабильность",

    archetype: "Труженик",
    psychology: "Прагматизм, внимательность к деталям",

    upright: {
      personality: "Терпение, ответственность",
      relationships: "Надёжный партнёр",
      work: "Процедуры, регламенты, стабильный прогресс",
      spirituality: "Дисциплина практики",
      examples: ["Регулярные отчёты", "Сопротивление хаосу"]
    },
    reversed: {
      meaning: "Застой, упрямство",
      nuances: "Заработался, нет гибкости"
    },

    associations: ["Поле", "Рутина", "Надёжность"],
    combinations: [
      "С Императором — сильная операционная дисциплина",
      "С Колесом Фортуны — адаптировать процессы к переменам"
    ],
    readingTips: [
      "Оптимизировать рутину",
      "Не путать стабильность с застойностью"
    ],
    selfQuestions: [
      "Что можно автоматизировать?",
      "Где надо стать гибче?"
    ]
  },
{
    id: "pentacles_13",
    arcana: "minor",
    suit: "pentacles",
    court: "queen",
    number: 13,
    name: "Королева Пентаклей",
    nameEn: "Queen of Pentacles",

    keywords: ["Забота", "Комфорт", "Хозяйственность"],

    symbolism: [
      "Женщина с пентаклем на троне",
      "Сад, виноград, кролик",
      "Тёплые землистые тона"
    ],
    symbolismInterpretation: "Питательная энергия, умелое управление ресурсами",

    archetype: "Берегиня дома",
    psychology: "Практичная щедрость, устойчивость",

    upright: {
      personality: "Заботливость, надёжность",
      relationships: "Тёплый быт, поддержка",
      work: "Операционное лидерство, HR-забота",
      spirituality: "Заземление, тело как храм",
      examples: ["Домашний уют", "Наставничество", "Финансовая грамотность"]
    },
    reversed: {
      meaning: "Чрезмерный контроль быта, материальность",
      nuances: "Забота без границ"
    },

    associations: ["Сад", "Кролик", "Дом"],
    combinations: [
      "С Императрицей — мощная созидающая энергия",
      "С Дьяволом — застревание в материальном"
    ],
    readingTips: [
      "Заботиться и о себе",
      "Строить устойчивые системы"
    ],
    selfQuestions: [
      "Как я создаю безопасность?",
      "Где перегибаю с контролем?"
    ]
  },
{
    id: "pentacles_14",
    arcana: "minor",
    suit: "pentacles",
    court: "king",
    number: 14,
    name: "Король Пентаклей",
    nameEn: "King of Pentacles",

    keywords: ["Изобилие", "Управление капиталом", "Надёжность"],

    symbolism: [
      "Мужчина на троне с скипетром и пентаклем",
      "Виноградники и бык",
      "Тяжёлые узоры мантии"
    ],
    symbolismInterpretation: "Мастерство в финансах и управлении, устойчивый результат",

    archetype: "Патрон",
    psychology: "Зрелая ответственность за ресурсы",

    upright: {
      personality: "Щедрость, надёжность",
      relationships: "Опора, защита",
      work: "Инвестиции, управление активами, предпринимательство",
      spirituality: "Материальное как служение",
      examples: ["Экосистема бизнеса", "Фонд, эндаумент"]
    },
    reversed: {
      meaning: "Алчность, авторитарность",
      nuances: "Риск ради статуса"
    },

    associations: ["Бык", "Виноград", "Трон"],
    combinations: [
      "С Императором — сильная власть и структура капитала",
      "Со Справедливостью — этика в финансах"
    ],
    readingTips: [
      "Сохранять этичность",
      "Делиться плодами"
    ],
    selfQuestions: [
      "Как я обращаюсь с властью денег?",
      "Что я оставлю после себя?"
    ]
  }
];


